import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LeaveService } from 'src/app/rest_services/msLeaveServices/leave.service';

@Component({
  selector: 'app-absence-update',
  templateUrl: './absence-update.component.html',
  styleUrls: ['./absence-update.component.css']
})
export class AbsenceUpdateComponent implements OnInit {

  updateRequestloading: any= true;
  updateAbsenceForm: any;
  id: any;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private leaveService : LeaveService,
    private location : Location,
    private router : Router
  ) { 
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);
    this.updateAbsenceForm = this.fb.group({
      type: ['', Validators.required],
      motif: [''],
      startDate: [formattedDate,  [Validators.required, this.startDateValidator]],
      endDate: [formattedDate,  [Validators.required, this.endDateValidator]],
    });

  }

  ngOnInit(): void {
    this.id= this.route.snapshot.paramMap.get('id')
    this.getLeave();
    
    var glob = this;

    $('body').on('click', ".upload__img-close", function (e:any) {
      const imgUrl = $(this).parent().css('background-image').replace(/^url\("data:image\/png;base64,|"?\)$/g, '');
      const index = glob.leavePictures.findIndex(picUrl => picUrl === imgUrl);
      if (index !== -1) {
          glob.leavePictures.splice(index, 1);
      }
      $(this).parent().parent().remove();
    });

  
  }

  goBack(){
    this.location.back();
  }
  
  leavePictures: any[] = [];
  imgArray: any[] = [];

  getLeave() {
    this.leaveService.getLeave(this.id);
    this.leaveService.leaveSubject.subscribe(
      (data : any)=>{
        if(data.status =='200'){
          const leaveData = data.leaveEnvelop;
          this.updateAbsenceForm.patchValue({
            type: leaveData.type,
            motif: leaveData.reason,
            startDate: this.formatDateToPatch(leaveData.start),
            endDate: this.formatDateToPatch(leaveData.finish)
          });
          this.adjustFloatingLabels();

          this.leavePictures = leaveData.attachements;
          // Display existing pictures
          const imgWrap = document.querySelector('.upload__img-wrap');
          if (imgWrap) {
              this.leavePictures?.forEach((pictureUrl, index) => {
                  const imgBox = `<div class='upload__img-box'><div style='background-image: url(data:image/png;base64,${pictureUrl})' data-number='${index}' class='img-bg'><div class='upload__img-close'></div></div></div>`;
                  imgWrap.innerHTML += imgBox;
              });
          }
          this.updateRequestloading=false;   
        }else{
          this.updateRequestloading=false;  
        }
      },
      (error :any) => {
        this.updateRequestloading=false;  
      }
    )
  }
  // Helper function to format date
  formatDateToPatch(dateString: string): string {
    // Assuming date is in format dd/mm/yyyy
    const parts = dateString.split('/');
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
  adjustFloatingLabels() {
    const inputFields = document.querySelectorAll('.mdl-textfield__input');
    inputFields.forEach((input) => {
      // Type casting to HTMLInputElement
      const inputElement = input as HTMLInputElement;
      
      const parentDiv = inputElement.parentElement;
      if (inputElement.value.trim() !== '') {
        parentDiv?.classList.add('is-focused', 'is-dirty');
      } else {
        parentDiv?.classList.remove('is-focused', 'is-dirty');
      }
    });
  }
  
  startDateValidator(control: any) {
    const startDate = new Date(control.value);
    const today = new Date();

    // Extract year, month, and day from the dates
    const startDateYear = startDate.getFullYear();
    const startDateMonth = startDate.getMonth();
    const startDateDay = startDate.getDate();

    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();
    const todayDay = today.getDate();

    // Compare year, month, and day
    if (startDateYear > todayYear ||
        (startDateYear === todayYear && startDateMonth > todayMonth) ||
        (startDateYear === todayYear && startDateMonth === todayMonth && startDateDay >= todayDay)) {
        return null; // Start date is today or later
    } else {
        return { invalidStartDate: true }; // Start date is before today
    }
  }

  endDateValidator(control: any) {
    const endDate = new Date(control.value);
    const startDate = new Date(control.parent?.get('startDate').value);
    const today = new Date();

    // Extract year, month, and day from the dates
    const endDateYear = endDate.getFullYear();
    const endDateMonth = endDate.getMonth();
    const endDateDay = endDate.getDate();

    const startDateYear = startDate.getFullYear();
    const startDateMonth = startDate.getMonth();
    const startDateDay = startDate.getDate();

    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();
    const todayDay = today.getDate();

    // Compare year, month, and day
    if (endDateYear > startDateYear ||
        (endDateYear === startDateYear && endDateMonth > startDateMonth) ||
        (endDateYear === startDateYear && endDateMonth === startDateMonth && endDateDay > startDateDay)) {
        // Check if the end date is after the start date
        return endDate >= today ? null : { invalidEndDate: true };
    } else {
        return { invalidEndDate: true }; // End date is before or same as start date
    }
  }

  addPic(event :any) {
    const imgWrap = document.querySelector('.upload__img-wrap');
    const files = event.target.files;
    const glob =this;
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file.type.match('image.*')) continue;
        this.imgArray.push(file);
  
      const reader = new FileReader();
      reader.onload = function(e) {
        var imgBox = "<div class='upload__img-box'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";

        if (imgWrap) {
          imgWrap.innerHTML += imgBox;
          if (glob.leavePictures == undefined || glob.leavePictures == null) {
            glob.leavePictures =[]
          }
          glob.leavePictures?.push(e.target?.result);
        }
      };
  
      reader.readAsDataURL(file);
    }
  }

  msg = '';
  updateAbsence() {
    this.updateAbsenceForm.markAllAsTouched();
    $("html, body").animate({scrollTop:0});
    if (this.updateAbsenceForm.valid) {
      $("html, body").animate({scrollTop:0});
      this.updateRequestloading= true;

      let startDate = new Date(this.updateAbsenceForm.get('startDate')?.value);
      let endDate = new Date(this.updateAbsenceForm.get('endDate')?.value);
      
      let reqBody = {
        id: this.id,
        type_leave: this.updateAbsenceForm.get('type')?.value,
        reason_leave: this.updateAbsenceForm.get('motif')?.value,
        start_leave: this.formatDate(startDate),
        finish_leave: this.formatDate(endDate),
        pj_leave: this.leavePictures
      };
      
      this.leaveService.updateLeave(reqBody, 'update');
      this.leaveService.updateLeaveSubject.subscribe(
        (data : any)=>{
          this.updateRequestloading= false;
          if(data.status == "200") {
            this.msg = ` a été mise à jour avec succès.`;
            (<any>$("#leave_updated")).show();
            setTimeout(() => {
              (<any>$("#leave_updated")).hide();   
              this.router.navigate(['/absence-detail/' + data.leaveId]);
            }, 3000);
          }else{
            (<any>$("#leave_not_updated")).show();
            setTimeout(() => {
              (<any>$("#leave_not_updated")).hide();          
            }, 3000);
          }
          
        },
        (error :any) => {
          this.updateRequestloading= false;
          this.updateAbsenceForm.reset();
          (<any>$("#leave_not_updated")).show();
          setTimeout(() => {
            (<any>$("#leave_not_updated")).hide();          
          }, 3000);
        }
      )
    }
  }
}
